<div class="row">
  <div class="col-2">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-10">
    <app-header></app-header>
    <div class="container" style="margin-top: 100px;">
      <div class="row" style="padding-top: 50px;">
        <div class="col-9">
          <h3>{{clinicName}}</h3>
        </div>
        <div class="col-3">
          <button class="btn btn-danger" data-toggle="modal" data-target="#exampleModal">Add test</button>
        </div>
      </div>
      <table class="table" style="margin-top: 50px;">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Test-Name</th>
            <th scope="col">Price</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of test let index = index">
            <th scope="row">{{index+1}}</th>
            <td>{{data.testId.name}}</td>
            <td>{{data.price}}</td>
            <td>
              <h5><i class="fa fa-pencil"  data-toggle="modal" data-target="#exampleModal" aria-hidden="true" style="margin-right: 20px;" (click)="curtest(data)"></i>
                <i class="fa fa-trash" (click)="deletTest(data)" aria-hidden="true"></i>
              </h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form [formGroup]="testForm" (ngSubmit)="editTest(testForm.value)">
              <input formControlName="testname" type="text" autocomplete="off" class="form-control"
                placeholder="Test-Name"><br>
              <input formControlName="price" type="text" autocomplete="off" class="form-control" placeholder="Price"><br>
              <button type="submit" class="btn btn-primary pull-right" style="background-color: #00cec9;">Add</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>